interface SimulationControlsBarProps {
  running: boolean
  onToggle: () => void
  onReset: () => void
  onStep?: () => void
  reducedMotion?: boolean
  disabled?: boolean
}

export function SimulationControlsBar({
  running,
  onToggle,
  onReset,
  onStep,
  reducedMotion = false,
  disabled = false,
}: SimulationControlsBarProps) {
  const stateLabel = reducedMotion ? 'Manual' : running ? 'Running' : 'Paused'
  return (
    <div className="simulation-controls">
      <div className="simulation-control-actions">
        {reducedMotion && onStep ? (
          <button type="button" onClick={onStep} disabled={disabled} className="simulation-button is-primary">Step</button>
        ) : (
          <button type="button" onClick={onToggle} disabled={disabled} className="simulation-button is-primary">{running ? 'Pause' : 'Resume'}</button>
        )}
        <button type="button" onClick={onReset} disabled={disabled} className="simulation-button">Reset</button>
      </div>
      <span className="simulation-state">State: {stateLabel}</span>
    </div>
  )
}
